import * as localStorageManager from 'constants/localStorageManager';
import { SESSION_TIME_OUT_INTERVAL } from 'constants/index';

const publicRoutes = [
  '/surveyreports',
  '/user_invitations',
  '/users/new',
  '/users/confirmation',
  '/events',
  '/login',
  '/passwords',
  '/signup',
  '/user_survey_rewards',
  '/onboarding',
];

document.onclick = () => {
  localStorageManager.setSessionTimeOut();
};

window.setInterval(CheckIdleTime, 1000);

function hasPublicRoute() {
  let isPublicRoute = false;

  publicRoutes.forEach(route => {
    isPublicRoute = isPublicRoute || document.location.pathname.includes(route);
  });

  return isPublicRoute;
}

function CheckIdleTime() {
  const isPublicRoute = hasPublicRoute();

  if (isSessionTimeOut()) {
    if (!isPublicRoute) {
      localStorageManager.clear();
      if (document.location.pathname != '/') {
        document.location.href = '/';
      }
    }
  }
}

export default function isSessionTimeOut() {
  const timeOut = localStorageManager.getSessionTimeOut();
  const timeOutDifference = Date.now() - timeOut;
  const timeOutLimit = SESSION_TIME_OUT_INTERVAL;
  if (timeOutDifference > timeOutLimit) return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/browserInactivity.js